module.exports = __webpack_public_path__ + "static/media/1_1.7ec2bbbd.png";